import { render, staticRenderFns } from "./BlogsEdit.vue?vue&type=template&id=583f7026&"
import script from "./BlogsEdit.vue?vue&type=script&lang=js&"
export * from "./BlogsEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports